module.exports = __webpack_public_path__ + "static/media/Ellipse.ea173bc6.png";